import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Autocomplete,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { PrincipalLayouts } from "../../../layouts";
import { FieldOpportunities } from "./FieldOpportunities";
import { useForm } from "../../../hooks";
import { DateInput } from "../DateInput";
import { addOpportunity } from "../../helpers/opportunity";
import { fetchData } from "../../helpers/getData/fetchData";
import { VisibilityList } from "./VisibilityList";

export const AddOpportunities = ({ startupList, vehiclesList }) => {
  const { t } = useTranslation("global");
  const navigate = useNavigate();
  const startupsNames = startupList.map((startup) => startup.name);
  const [userWithActivePosition, setUserWithActivePosition] = useState([]);

  const [userList, setuserList] = useState([]);
  const [checked, setChecked] = useState(userList);

  useEffect(() => {
    fetchData(setuserList, `/user`, t);
  }, [t]);

  const [isWaiting, setIsWaiting] = useState(false);
  const [formValues, handleInputChange, reset] = useForm({
    dateOpportunity: "",
    reservationDeadline: "",
    investmentType: "Ampliación Capital",
    roundNumber: "",
    urlVideo: "",
    startup: startupsNames[0],
    status: "Activo",
    vehicle: vehiclesList[0],
    clubFilter: ["España"],
    isActiveFilter: "Activos",
  });

  const {
    dateOpportunity,
    reservationDeadline,
    investmentType,
    urlVideo,
    startup,
    status,
    vehicle,
  } = formValues;

  useEffect(() => {
    const startupId = startupList.find((start) => start.name === startup)?.id;
    fetchData(
      setUserWithActivePosition,
      `/user/getUsersWithActivePosition/${startupId}`,
      t
    );
    // eslint-disable-next-line no-undef, react-hooks/exhaustive-deps
  }, [startup]);

  const handleConfirm = async (e) => {
    e.preventDefault();
    setIsWaiting(true);
    let dataForm = formValues;
    const startupSelected = startupList.find((p) => p.name === startup);
    const visibility = JSON.stringify(checked?.map((user) => user?.id));
    dataForm = {
      ...formValues,
      startupId: startupSelected?.id,
      visibility,
      clubFilter: JSON.stringify(formValues.clubFilter),
    };
    await addOpportunity(
      dataForm,
      t("opportunities.successMsgAdd"),
      t("opportunities.errorMsg"),
      navigate
    );
    setIsWaiting(false);
    reset();
  };
  const handleCancel = () => {
    reset();
    navigate("/opportunities");
  };

  return (
    <PrincipalLayouts>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography color="primary" variant="h5">
          {t("opportunities.titlePage")}
        </Typography>
      </Stack>
      <Divider sx={{ marginTop: 2, marginBottom: 3 }} />

      <form onSubmit={handleConfirm}>
        <Stack width="100%" gap={2}>
          <Stack direction="column" width="100%" gap={0}>
            <Typography variant="overline" color="secondary">
              {t("opportunities.startup")}
            </Typography>
            <Autocomplete
              disablePortal
              options={startupsNames}
              size="small"
              renderInput={(params) => (
                <TextField {...params} variant="outlined" name="startup" />
              )}
              value={startup}
              onSelect={handleInputChange}
              fullWidth
              required
            />
          </Stack>
          <Stack direction="column" width="100%" gap={0}>
            <Typography variant="overline" color="secondary">
              {t("opportunities.investmentType")}
            </Typography>
            <Autocomplete
              disablePortal
              options={["Ampliación Capital", "Préstamo Convertible"]}
              size="small"
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  name="investmentType"
                />
              )}
              value={investmentType}
              onSelect={handleInputChange}
              fullWidth
              required
            />
          </Stack>
          <Stack direction="column" width="100%" gap={0}>
            <Typography variant="overline" color="secondary">
              {t("opportunities.status")}
            </Typography>
            <Autocomplete
              disablePortal
              options={["Activo", "Inactivo"]}
              size="small"
              renderInput={(params) => (
                <TextField {...params} variant="outlined" name="status" />
              )}
              value={status}
              onSelect={handleInputChange}
              fullWidth
              required
            />
          </Stack>

          <Stack direction="row" width="100%" gap={2}>
            <DateInput
              name={dateOpportunity}
              title="dateOpportunity"
              handleInputChange={handleInputChange}
              required={true}
            />
            <DateInput
              name={reservationDeadline}
              title="reservationDeadline"
              handleInputChange={handleInputChange}
              required={true}
              hasMin={true}
            />
          </Stack>

          <Stack width="100%">
            <FieldOpportunities
              name={urlVideo}
              title="urlVideo"
              handleInputChange={handleInputChange}
            />
          </Stack>

          <Stack direction="column" width="100%" gap={0}>
            <Typography variant="overline" color="secondary">
              {t("opportunities.vehicle")}
            </Typography>
            <Autocomplete
              disablePortal
              options={vehiclesList}
              size="small"
              renderInput={(params) => (
                <TextField {...params} variant="outlined" name="vehicle" />
              )}
              value={vehicle}
              onSelect={handleInputChange}
              fullWidth
              required
            />
          </Stack>
        </Stack>
        {userList.length > 0 && (
          <VisibilityList
            formValues={formValues}
            handleInputChange={handleInputChange}
            userList={userList.filter(
              (user) => user.role === "Club" || user.role === "Híbrido"
            )}
            checked={checked}
            setChecked={setChecked}
            userWithActivePosition={userWithActivePosition}
          />
        )}
        <Stack direction="row" justifyContent="end" gap={2} marginTop={3}>
          <Button
            sx={{ width: "140px" }}
            color="secondary"
            onClick={handleCancel}
            variant="outlined"
          >
            {t("myprofile.cancelButton")}
          </Button>
          <Button
            disabled={isWaiting || vehicle === ""}
            sx={{ width: "140px" }}
            type="submit"
            variant="contained"
          >
            {t("myprofile.confirmButton")}
          </Button>
        </Stack>
      </form>
    </PrincipalLayouts>
  );
};
